import { Link } from "react-router-dom";
import { Phone } from "lucide-react";

export default function Footer({ content }) {
  return (
    <footer className="border-t border-gold/15 bg-storm-800/30" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-14">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-10">
          <div>
            <img src="/logo.png" alt="DRC502 Construction LLC" className="h-16 w-auto object-contain" data-testid="footer-logo" />
            <p className="mt-4 font-mono text-[11px] uppercase tracking-[0.25em] text-gold">{content.tagline}</p>
            <p className="mt-2 text-sm text-slate-500 max-w-xs">{content.area_text}</p>
          </div>
          <div className="flex flex-col gap-3">
            <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-slate-500">Services</span>
            {(content.services || []).map((s) => (
              <a key={s.title} href="#services" data-testid={`footer-service-${s.title.toLowerCase().replace(/\s+/g, "-")}`}
                className="text-sm text-slate-400 hover:text-gold transition-colors">
                {s.title}
              </a>
            ))}
          </div>
          <div className="flex flex-col gap-3">
            <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-slate-500">Contact</span>
            <a href={`tel:${content.phone_tel}`} data-testid="footer-phone-link"
              className="inline-flex items-center gap-2 text-sm text-slate-400 hover:text-gold transition-colors">
              <Phone size={14} /> {content.phone_display}
            </a>
            <span className="text-sm text-slate-400">{content.email}</span>
            <span className="text-sm text-slate-500">{content.hours_text}</span>
            <Link to="/admin" data-testid="footer-admin-link" className="text-xs text-slate-600 hover:text-gold transition-colors mt-2">
              Admin Portal
            </Link>
          </div>
        </div>
        <div className="mt-12 pt-6 border-t border-gold/10 flex flex-col sm:flex-row justify-between gap-3">
          <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-slate-600" data-testid="footer-copyright">
            © {new Date().getFullYear()} {content.company_name}. All rights reserved.
          </p>
          <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-slate-600">
            Quality — Integrity — Reliable Results
          </p>
        </div>
      </div>
    </footer>
  );
}
